import content from "../db.js";

const userInfo = {
    fetchData: () => {
        return content;
    }
};

export default userInfo;